import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {
    HeavyPanelContent, Panel, PanelGroup,
    Section
} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {PanelContentProps, PanelView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import bind from 'bind-decorator';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {HeavyPanelView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/HeavyPanelView';
import {PanelHeaderView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelHeaderView';

const styles = require('./PanelGroupView.less');
const cx = classnames.bind(styles);

export interface PanelGroupViewProps extends PanelContentProps
{
    section:Section;
    group:PanelGroup;
}

@observer
export class PanelGroupView extends React.Component<PanelGroupViewProps, any>
{
    @bind
    private _renderBodiesOnly(panels:Panel[])
    {
        return  <div className={cx('panelGroupView')}>
                    {this._renderBodies(panels)}
                </div>;
    }

    @bind
    private _renderWithTitles(panels:Panel[])
    {
        return  <div className={cx('panelGroupView')}>
                    {this._renderHeaders(panels)}
                    {this._renderBodies(panels)}
                </div>;
    }

    @bind
    private _hasTitles(panels:Panel[]):boolean
    {
        let hasTitles = false;

        panels.map((p:Panel)=>
        {
            if( p.header.title )
                hasTitles = true;
        });

        return hasTitles;
    }

    @bind
    private _renderBodies(panels:Panel[])
    {
        const {section} = this.props;

        return  <div className={cx('panelBodies')}>
                {
                    this._renderHeavyBodies()
                }
                {
                    this._renderRegularPanelBodies(panels, section)
                }
                </div>;
    }

    @bind
    private _renderHeavyBodies()
    {
        const {group} = this.props;
        const heavyPanelContents = group.heavyPanelContents;
        const controller = controllers.ui.panels.general;

        if( heavyPanelContents )
        {
            return heavyPanelContents.map((hpc:HeavyPanelContent)=>
            {
                const isVisible = controller.isHeavyContentVisible(group, hpc);

                return  <div key={hpc.forPanelKind}
                             className={cx('panelBody',
                                          {'visiblePanel': isVisible},
                                          {'hiddenPanel' : !isVisible}
                        )}>
                            <HeavyPanelView isVisible={true}
                                            heavyContent={hpc.content}
                                            onPanelResize={this.props.onPanelResize}/>
                        </div>;

            });
        }
        else
            return null;
    }

    private _renderRegularPanelBodies(panels: Panel[], section: Section)
    {
        return panels.map((panel: Panel) =>
                          {
                              return this._renderRegularPanelBody(section, panel);
                          });
    }

    private _renderRegularPanelBody(section:Section, panel:Panel)
    {
        const group = this.props.group;
        const controller = controllers.ui.panels.general;
        const isSelectedAndActive = controller.isPanelSelectedAndActive(group, panel);
        const isHeavyPanelKind = controller.isHeavyPanelKind(group, panel.kind);

        if( isHeavyPanelKind )
            return null;
        else
            return  <div key={panel.id} className={cx('panelBody',
                                                      {'visiblePanel': isSelectedAndActive},
                                                      {'hiddenPanel': !isSelectedAndActive})}>
                        <PanelView section={section}
                                   panel={panel}
                                   onPanelResize={this.props.onPanelResize}/>
                    </div>;
    }

    @bind
    private _renderHeaders(panels:Panel[])
    {
        const {group} = this.props;

        return  <div className={cx('panelHeaders')}>
                {
                    panels.map((panel: Panel) =>
                    {
                        return <PanelHeaderView key={panel.id} group={group} panel={panel}/>;
                    })
                }
                </div>;

    }

    render()
    {
        const {group} = this.props;
        const {panels} = group;

        const hasTitles = this._hasTitles(panels);

        if( hasTitles )
            return this._renderWithTitles(panels);
        else
            return this._renderBodiesOnly(panels);
    }
}











